import { z } from 'zod/v4';

import { entityStateSchema } from './entity-state.schema';
import { roleSchema } from './role.schema';

export const accountRoleSchema = z.object({
  accountAlias: z.string().nullable(),
  accountId: z.number().min(1),
  accountName: z.string().min(1),
  accountState: z.number(),
  expirationDate: z.string().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  roleName: roleSchema.nullable(),
  userId: z.number(),
  userName: z.string().nullable(),
  userState: entityStateSchema,
});

export type AccountRole = z.infer<typeof accountRoleSchema>;
